
$(document).ready(function() {

  var collectionPageElementsHeight = $('#shopify-section-header').height() + $('.collection-line').height() + 112;
  if ($('#shopify-section-announcement-bar-progress-bar').length > 0) {
    collectionPageElementsHeight += $('#shopify-section-announcement-bar-progress-bar').height();
  }
  // SV-removed
  /*
  if ($('.collection-banner').length > 0) {
    collectionPageElementsHeight += $('.collection-banner').height();
  }
  */
  $('.collection-line .collection-filters-bar .collection-filters-tabs').css('height', 'calc(100vh - ' + collectionPageElementsHeight + 'px)');

  const handleSelectEvent = (event) => {
    var productForm = $(event.target.closest('.collection-product-form'));
    var form = $('form', productForm);
    var options = $('.collection-product-options', productForm);
    var price = $('.collection-product-price', productForm.closest('.collection-product'));
    var variants = options.data('variants');

    var variant = null;
    var option1 = null;
    var option2 = null;
    var option3 = null;

    $.each($('.product-form__input', options), function(k, v) {
      var select = $('select', $(v));

      if (k === 0) {
        option1 = select.val();
      } else if (k === 1) {
        option2 = select.val();
      } else if (k === 2) {
        option3 = select.val();
      }
    });


    if (!variant) {
      $.each(variants, function(k, v) {
        if (v.option1 === option1 && v.option2 === option2 && v.option3 === option3 && v.available) {
          variant = variant || v;
        }
      });
    }

    if (!variant) {
      $.each(variants, function(k, v) {
        if (v.option1 === option1 && v.option2 === option2 && v.available) {
          variant = variant || v;
        }
      });
    }

    if (!variant) {
      $.each(variants, function(k, v) {
        if (v.option1 === option1 && v.available) {
          variant = variant || v;
        }
      });
    }

    if (!variant) {
      $.each(variants, function(k, v) {
        if (v.available) {
          variant = variant || v;
        }
      });
    }

    if (!variant) {
      variant = variant || variants[0];
    }

    // Update afterpay price with variant change
    let $formWrap = productForm.closest('.collection-product');
    let $afterpay = $formWrap.find('afterpay-placement');
    if ($afterpay) {
      $afterpay.each((index, item) => {
        item.dataset.amount = (variant.price / 100);
      });
    }

    $('[name="id"]', form).val(variant.id);
    if (variant.compare_at_price > 0) {
      if (!price.hasClass('sale')) {
        price.addClass('sale');
      }
      price.html('<span class="old">' + formatMoney(variant.compare_at_price) + '</span> ' + formatMoney(variant.price));
    } else {
      price.removeClass('sale');
      price.html(formatMoney(variant.price));
    }

    /* Update Out of stock properly */
    const selectElements = options[0].querySelectorAll('.collection-product-options select')

    selectElements.forEach((selectElement, index) => {
      selectElement.querySelectorAll('option').forEach(option => {
        if (index === 0) {
          option.disabled = variants.filter(v=> v.options[index] === option.value).every(v=> !v.available)
       }
        if (index === 1) {
          option.disabled = variants.filter(v=> v.options[0] === option1 && v.options[index] === option.value).every(v=> !v.available)
        }
        if (index === 2) {
          option.disabled = variants.filter(v=> v.options[0] === option1 && v.options[1] === option2 && v.options[index] === option.value).every(v=> !v.available)
        }
        option.selected = variant.options[index] === option.value
      })
    })
  }

  $('.collection-product-options select').on('change', handleSelectEvent);

  document.querySelectorAll('.collection-product-options select').forEach(selectElement => {
    selectElement.dispatchEvent(new Event('change'))
  })

  initUpsellProduct();
});

const JSONParse = (string) => {
  try {
    return JSON.parse(string)
  } catch (err) {
    return null
  }
}

function initUpsellProduct() {
  const upsellContainer = document.querySelector('[data-upsell-product]')
  if (!upsellContainer) return;

  const variants = JSONParse(upsellContainer.dataset.upsellProduct);
  const priceElement = upsellContainer.querySelector('[data-upsell-product-price]')
  const selectElement = upsellContainer.querySelector('[data-upsell-product-select]')

  const handleChange = (e) => {
    const variant = variants.find(v=> +v.id === +selectElement.value)
    if (variant) {
      priceElement.innerHTML = `
        <div class="collection-product-price ${variant.compare_at_price > variant.price ? "sale": ""}">
        ${variant.compare_at_price > variant.price ? `<span class="old" style="opacity: 0.6">${formatMoney(variant.compare_at_price)}</span>`: ""}
        ${formatMoney(variant.price)}
      </div>`
    }
  }
  handleChange();
  selectElement.addEventListener('change', handleChange)
}